/// <amd-module name="Repos/FilesHubCommon/FilesHubFilterActionsService" />
import * as React from "react";
import * as Resources from "Repos/FilesHubCommon/Resources";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { css, IVssLayoutManager } from "VSS/Platform/Layout";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

/**
 * Tabs within the FilesHub should include the common actions in the
 * list of actions rendered in the renderFilterBar callback for their
 * tab.
 */
export interface IFilesHubFilterActionsService extends IVssService {
    getActions(): IHeaderCommandBarItem[];
}

class FilesHubFilterActionsService extends VssService implements IFilesHubFilterActionsService {
    public getActions(): IHeaderCommandBarItem[] {
        return [
            {
                ariaLabel: Resources.ToggleFullScreenMode,
                iconProps: {
                    render: (className?: string) => {
                        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                        return (
                            <Observer fullScreenMode={layoutManager.getFullScreenMode()}>
                                {(props: { fullScreenMode: boolean }) => (
                                    <Icon className={css(className, "medium")} iconName={props.fullScreenMode ? "BackToWindow" : "FullScreen"} />
                                )}
                            </Observer>
                        );
                    }
                },
                id: "fullscreen",
                onActivate: () => {
                    const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
                    layoutManager.setFullScreenMode(!layoutManager.getFullScreenMode().value);
                },
                subtle: true,
                tooltipProps: { text: Resources.ToggleFullScreenMode }
            }
        ];
    }
}

Services.add("IFilesHubFilterActionsService", { serviceFactory: FilesHubFilterActionsService });
